var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-survey-agressive-entry"},[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.surveyAnalysisTabels},scopedSlots:_vm._u([{key:"activity",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityName(row.id)))])]}},{key:"very-nagative",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.VERY_NEGATIVE].percent)))])]}},{key:"nagative",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.NEGATIVE].percent)))])]}},{key:"normal-nagative",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.SOMEWHAT_NEGATIVE].percent)))])]}},{key:"normal",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.NEUTRAL].percent)))])]}},{key:"normal-active",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.SOMEWHAT_ACTIVE].percent)))])]}},{key:"active",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.ACTIVE].percent)))])]}},{key:"very-active",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(row.pointList[_vm.stageIndex.VERY_ACTIVE].percent)))])]}},{key:"aggressive-entry-rate",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(_vm.calcAggressiveEntryPercent(row))))])]}},{key:"more-aggressive-entry-rate",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.formatPercent(_vm.calcStrongAggressivePercent(row))))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }